// Backend Base Url

// LIVE
export const BACKEND_BASE_URL = "https://hotelnxt.com";
export const IMAGE_HOST = "https://storage.hotelnxt.com";

// LOCAL
// export const BACKEND_BASE_URL = "http://localhost:8000";
// export const IMAGE_HOST = "http://192.168.0.101:1337";

// -----------------------
// MediaBase Url
export const PROJECT_MEDIA_FOLDER = "hotelnxt";
export const IMAGE_BASE_URL = IMAGE_HOST + "/" + PROJECT_MEDIA_FOLDER + "/";
// -----------------------
// SubPath
export const API_URL = BACKEND_BASE_URL + "/api";

// Location API
export const LOCATIONS = "locations?country_id=";

// File-Upload API
export const ALL_UPLOADED_FILE = "files/folder-wise";
export const FOLDERS = "files/folders";
export const FILES_BY_FOLDER = "files/by-folder";
export const FILE_UPLOAD = "files/multi_upload";
export const FILE_UPDATE = "files/update";
export const FILE_DESTROY = "files/delete";

// Auth API
export const LOGIN = "login";
export const REGISTER = "register";
export const SENT_OTP = "mail-verification";
export const VERIFY_OTP = "forgot-password";
export const DASH_DATA = "dashboard-data?period=";

// User Wallet API
export const USER_WALLET_HISTORY = "userWalletHistory";
export const USER_WALLET_HISTORY_CREATE = "createWalletHistory";

// User API
export const USER = "user/customer";
export const STAFF = "user/staff";
export const USER_DETAIL = "user/by_id";
export const USER_DETAIL_MOBILE = "user/by_mobile";
export const ADD_USER = "user/create";
export const EDIT_USER = "user/update";
export const DELETE_USER = "user/delete";

// SEO API
export const ALL_SEO = "seo";
export const SEO_BY_ID = "seo/detail";
export const CREATE_SEO = "seo/create";
export const EDIT_SEO = "seo/update";
export const DELETE_SEO = "seo/destroy";

// Contacts API
export const ALL_CONTACTS = "contact";
export const DELETE_CONTACTS = "contact/destroy";

// Newsletter API
export const ALL_NEWSLETTER = "newsletter";
export const DELETE_NEWSLETTER = "newsletter/destroy";

// Career Query's API
export const ALL_CAREER_QRY = "career-query";
export const UPDATE_CAREER_QRY = "career-query/update";
export const DELETE_CAREER_QRY = "career-query/destroy";

// Blog/News API
export const ALL_BLOG = "blog";
export const BLOG_BY_ID = "blog/detail";
export const CREATE_BLOG = "blog/create";
export const EDIT_BLOG = "blog/update";
export const DELETE_BLOG = "blog/destroy";

// Carrer (Jobs) API
export const ALL_CAREER = "career";
export const CAREER_BY_ID = "career/detail";
export const CREATE_CAREER = "career/create";
export const EDIT_CAREER = "career/update";
export const DELETE_CAREER = "career/destroy";

// Lead API
export const ALL_LEAD = "lead";
export const LEAD_BY_ID = "lead/detail";
export const CREATE_LEAD = "lead/create";
export const EDIT_LEAD = "lead/update";
export const DELETE_LEAD = "lead/destroy";

// Gallery API
export const ALL_GALLERY = "gallery";
export const GALLERY_BY_ID = "gallery/detail";
export const CREATE_GALLERY = "gallery/create";
export const EDIT_GALLERY = "gallery/update";
export const DELETE_GALLERY = "gallery/destroy";

// Team API
export const ALL_TEAM = "team";
export const TEAM_BY_ID = "team/detail";
export const CREATE_TEAM = "team/create";
export const EDIT_TEAM = "team/update";
export const DELETE_TEAM = "team/destroy";

// Testimonial API
export const ALL_TESTIMONIAL = "testimonial";
export const TESTIMONIAL_BY_ID = "testimonial/detail";
export const CREATE_TESTIMONIAL = "testimonial/create";
export const EDIT_TESTIMONIAL = "testimonial/update";
export const DELETE_TESTIMONIAL = "testimonial/destroy";

// Dynamic Content  API
export const ALL_DYNAMIC_CONTENT = "pages";
export const DYNAMIC_CONTENT_LIST = "pages-list";
export const DYNAMIC_CONTENT_BY_ID = "pages/detail";
export const CREATE_DYNAMIC_CONTENT = "pages/create";
export const EDIT_DYNAMIC_CONTENT = "pages/update";
export const DELETE_DYNAMIC_CONTENT = "pages/destroy";

// Slider-Banner  API
export const ALL_SLIDER = "slider";
export const SLIDER_BY_ID = "slider/detail";
export const CREATE_SLIDER = "slider/create";
export const EDIT_SLIDER = "slider/update";
export const DELETE_SLIDER = "slider/destroy";

// Setting API
export const CREATE_SETTING = "system-setting/manage";
export const SETTING = "system-setting";

// Subscription Plan
export const ALL_SUBSCRIPTION_PLAN = "subscription-plans";
export const CREATE_SUBSCRIPTION_PLAN = "subscription-plans/create";
export const EDIT_SUBSCRIPTION_PLAN = "subscription-plans/update";
export const DELETE_SUBSCRIPTION_PLAN = "subscription-plans/destroy";
export const SUBSCRIPTION_PLAN_BY_ID = "subscription-plans/detail";

// Vendor
export const ALL_VENDOR = "vendors";
export const CREATE_VENDOR = "vendors/create";
export const EDIT_VENDOR = "vendors/update";
export const DELETE_VENDOR = "vendors/destroy";
export const VENDOR_BY_ID = "vendors/detail";
export const UPCOMING_BILLING = "vendors/upcoming-billing";
export const VENDOR_BILLING_DETAIL = "vendors/billing-detail";
export const PURGE_VENDOR = "vendors/purge";


// Vendor Rooms
export const CREATE_VENDOR_ROOMS = "vendor-rooms/create";
export const EDIT_VENDOR_ROOMS = "vendor-rooms/update";
export const DELETE_VENDOR_ROOMS = "vendor-rooms/destroy";

// Vendor Rooms
export const MANAGE_VENDOR_DOCUMENTS = "vendor-documents/upload";
export const UPDATE_VENDOR_DOCUMENT_STATUS = "vendor-documents/update-status";
export const DELETE_VENDOR_DOCUMENTS = "vendor-documents/destroy";

// Vendor Bills
export const ALL_VENDOR_BILLS = "vendor/bills";
export const CREATE_VENDOR_BILL = "vendor/bill/create";
export const EDIT_VENDOR_BILL = "vendor/bill/update";
export const GENERATE_VENDOR_BILL = "vendor/bill/generate";
export const CANCEL_VENDOR_BILL = "vendor/bill/cancel";

export const BILL_RAISE_DISCOUNT = "vendor/bill/raise-discount";
export const BILL_ACTION_DISCOUNT = "vendor/bill/action-discount";
export const ADMIN_PENDING_DISCOUNTS = "vendor/bill/pending-discount";

// Invoice Path
export const BILL_INVOICE = API_URL + "/vendor/bill/invoice?id=";




export const BILL_TRANS_CREATE = "vendor/bill/transaction/create";
export const RAZORPAY_ORDER_CREATE = "vendor/bill/transaction/razorpay/order";
export const RAZORPAY_VERIFY = "vendor/bill/transaction/razorpay/verify";
export const BILL_RAZORPAY_LINK_GEN = "vendor/bill/transaction/razorpay/link";
export const WEBHOOKS_LOGS = "webhook-logs/list";
export const VENDOR_BILL_LOGS = "vendor-bill-logs/list";
export const VENDOR_BILL_DISCOUNT_LOGS = "vendor-bill-discount-logs/list";



// Discount Coupons
export const ALL_DISCOUNT_COUPON = "discounts";
export const CREATE_DISCOUNT_COUPON = "discounts/create";
export const EDIT_DISCOUNT_COUPON = "discounts/update";
export const DELETE_DISCOUNT_COUPON = "discounts/destroy";
export const DISCOUNT_COUPON_BY_ID = "discounts/detail";

// Facility API
export const ALL_FACILITY = "facilities";
export const FACILITY_BY_ID = "facilities/detail";
export const CREATE_FACILITY = "facilities/create";
export const EDIT_FACILITY = "facilities/update";
export const DELETE_FACILITY = "facilities/destroy";
